import React from 'react';
import { Card } from './ui/Card';
import { Stat } from '../utils/types';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function StatsCard({
  label,
  value,
  icon: Icon,
  trend,
  trendUp,
  color = 'blue'
}: Stat) {
  const colorMap = {
    teal: 'bg-teal-50 text-[#1DBAB4]',
    blue: 'bg-blue-50 text-blue-600',
    red: 'bg-red-50 text-red-600',
    purple: 'bg-purple-50 text-purple-600',
    amber: 'bg-amber-50 text-amber-600',
    green: 'bg-green-50 text-green-600'
  };
  const bgColor = colorMap[color as keyof typeof colorMap] || colorMap.blue;
  return <Card hover={false} className="p-4 sm:p-6" data-id="element-177">
      <div className="flex items-start justify-between gap-3" data-id="element-178">
        <div className="flex-1 min-w-0" data-id="element-179">
          <p className="text-caption mb-1 truncate" data-id="element-180">{label}</p>
          <motion.h3 className="text-2xl sm:text-3xl font-bold text-gray-900" initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} data-id="element-181">
            {value}
          </motion.h3>
        </div>
        <div className={`p-2.5 sm:p-3 ${bgColor} rounded-lg flex-shrink-0`} data-id="element-182">
          <Icon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-183" />
        </div>
      </div>
      {trend && <div className="mt-3 sm:mt-4 flex items-center gap-1 text-xs sm:text-sm" data-id="element-184">
          {trendUp ? <ArrowUpRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-500 flex-shrink-0" data-id="element-185" /> : <ArrowDownRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-red-500 flex-shrink-0" data-id="element-186" />}
          <span className={`font-medium ${trendUp ? 'text-green-600' : 'text-red-600'}`} data-id="element-187">
            {trend}
          </span>
          <span className="text-gray-500 ml-1 truncate" data-id="element-188">vs mois dernier</span>
        </div>}
    </Card>;
}